<template>
    <div class=" p_t">
        <TopHead title="场馆详情"></TopHead>
        <!--顶部的富文本-->
        <div class="a_top">
            <div class="f_title">{{info.title}}</div>
            <div class="f_content" v-html="info.contentInfo"></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            contentId:0,
            info:{}
        };
    },
    created() {
        this.contentId = this.$route.query.contentId
        this.getContent()
    },
    methods: {
        getContent(){
            this.$api.queryContentById(this.contentId).then(res=>{
                // console.log(res);
                if(res.status == 1){
                    this.info = res.data
                }else{
                    this.$toast(res.message)
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.a_top{
    .f_content{
      margin-top: 17px;
        ::v-deep img{
        max-width: 100% !important;
        height: auto;
      }
    }
    padding: 20px 12px 20px;
  }
  .f_title.sub{
    font-size: 10px;
    margin-bottom: 18px;
    font-weight: lighter;
    color: #FFFFFF;
    margin-top: -5px;
    &.s{
      font-size: 12px;
      margin-top: 3px;
    }
  }
</style>
